module.exports = __webpack_public_path__ + "img/skull_stroke_summary.172c5334.png";